import { Send } from "lucide-react";
import type { Hsb } from "../color";
import {
  HUE_GRADIENT,
  brightnessGradient,
  saturationGradient,
} from "../color";
import { copy } from "../copy";
import { Slider } from "./Slider";

export function Controls({
  guess,
  onGuess,
  onSubmit,
  isLastRound,
}: {
  guess: Hsb;
  onGuess: (next: Hsb) => void;
  onSubmit: () => void;
  isLastRound: boolean;
}) {
  return (
    <div className="controls" role="group" aria-label="색 조절판">
      <Slider
        label={copy.hue}
        value={guess.hue}
        max={360}
        gradient={HUE_GRADIENT}
        onChange={(hue) => onGuess({ ...guess, hue })}
      />
      <Slider
        label={copy.saturation}
        value={guess.saturation}
        max={100}
        gradient={saturationGradient(guess)}
        onChange={(saturation) => onGuess({ ...guess, saturation })}
      />
      <Slider
        label={copy.brightness}
        value={guess.brightness}
        max={100}
        gradient={brightnessGradient(guess)}
        onChange={(brightness) => onGuess({ ...guess, brightness })}
      />
      <button className="primary submit" onClick={onSubmit}>
        <Send size={18} />
        {isLastRound ? `${copy.submit} · ${copy.complete}` : copy.submit}
      </button>
    </div>
  );
}
